export default () => (
  <svg width='32' height='32' viewBox='0 0 112 112' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect width='112' height='112' fill='#78A300' />
    <path d='M60.2 34.3L34.5 27L27.8 50.9L20 78.3L45.7 85.5L52.9 59.9L60.2 34.3Z' fill='white' />
    <path d='M67.2996 85.5L92.9996 78.2999L85.6996 52.7L60.0996 59.9L67.2996 85.5Z' fill='#00363D' />
  </svg>
)
